import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { SIZES, CURRENCY_SYMBOL, waProduct } from '../config/pricing';
import { productHue } from '../data/products';

export default function ProductCard({ product, onAdd, onOpen }) {
  const [imgOk, setImgOk] = useState(true);
  const size = SIZES[0];
  const hue = productHue(product.id);
  const openProduct = () => onOpen?.(product);

  return (
    <article
      className="card"
      aria-labelledby={`p-${product.id}`}
      role="button"
      tabIndex={0}
      onClick={(e) => {
        if (e.target.closest('button, a')) return;
        openProduct();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openProduct();
        }
      }}
    >
      <div className="card-media" style={{ '--h': hue }}>
        {product.giftReady && <span className="tag-gift">Gift</span>}
        {imgOk ? (
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            width="640"
            height="704"
            decoding="async"
            onError={() => setImgOk(false)}
          />
        ) : (
          <div className="mini-bottle" aria-hidden="true" />
        )}
      </div>

      <div className="card-body">
        <span className="card-cat">{product.category}</span>
        <h3 id={`p-${product.id}`} className="card-title">{product.name}</h3>
        <p className="card-desc">{product.description}</p>

        <div className="product-offer" aria-label={`${size.label}, ${CURRENCY_SYMBOL}${size.price}`}>
          <span className="offer-size"><strong>{size.ml}ml</strong><small>Oud oil</small></span>
          <strong className="offer-price">{CURRENCY_SYMBOL}{size.price}</strong>
        </div>

        <div className="card-actions">
          <button
            type="button"
            className="btn btn-gold"
            onClick={(e) => {
              e.stopPropagation();
              onAdd(product, size, 1);
            }}
            aria-label={`Add ${product.name}, ${size.label}, to cart`}
          >
            Add to Bag
          </button>
          <a
            className="btn btn-ghost card-wa"
            href={waProduct(product.name, size.label)}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Order ${product.name} on WhatsApp`}
            onClick={(e) => e.stopPropagation()}
          >
            <MessageCircle size={16} />
          </a>
        </div>

        <button
          type="button"
          className="details-toggle"
          onClick={(e) => {
            e.stopPropagation();
            openProduct();
          }}
        >
          View fragrance
        </button>
      </div>
    </article>
  );
}
